// extracted by mini-css-extract-plugin
export default {"main":"index_main_x8Om1 clearfix w1000"};